import { render } from "./card2.vue?vue&type=template&id=125fbc71&scoped=true"
import script from "./card2.vue?vue&type=script&lang=ts"
export * from "./card2.vue?vue&type=script&lang=ts"

import "./card2.vue?vue&type=style&index=0&id=125fbc71&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-125fbc71"

export default script